import { useTranslation } from 'react-i18n-lite'

import ActivityValue from './ActivityValue'
import { formatFileSize } from 'modules/shared/utils/formatFileSize'
import { StatusClass } from 'types/shared'
import { useDocumentURL } from 'modules/document/hooks'
import { MarkedImage, Values } from '../../ActivityInput/ActivityMarkPhoto'

interface ActivityMarkPhotoProps {
  values: string
  statusClass?: StatusClass
  hideDescription?: boolean
}

const ActivityMarkPhoto = ({
  values,
  statusClass,
  hideDescription
}: ActivityMarkPhotoProps) => {
  const { t } = useTranslation()

  const parsedValues = JSON.parse(values) as Values

  const { documentURL } = useDocumentURL({ s3PrivateURL: parsedValues?.url })

  const { des, marks = [] } = parsedValues

  return (
    <>
      {!hideDescription && (
        <ActivityValue
          label={t('activity-document-photo.labels.des')}
          value={parsedValues.des}
          statusClass={statusClass}
        />
      )}
      <ActivityValue
        label={t('activity-document-photo.labels.uuid-foto')}
        value={parsedValues.uuid}
        statusClass={statusClass}
        placeholder={t('activity-document-photo.placeholders.uuid-foto')}
      />
      <ActivityValue
        label={t('activity-document-photo.labels.status')}
        value={parsedValues.statusDes}
        statusClass={statusClass}
        placeholder={t('activity-document-photo.placeholders.status')}
      />
      <div className='row'>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-photo.labels.content-type')}
            value={parsedValues.contentType}
            statusClass={statusClass}
            placeholder={t('activity-document-photo.placeholders.content-type')}
          />
        </div>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-photo.labels.size')}
            value={
              parsedValues.size ? formatFileSize(Number(parsedValues.size)) : ''
            }
            statusClass={statusClass}
            placeholder={t('activity-document-photo.placeholders.size')}
          />
        </div>
      </div>
      <div className='w-100 d-flex justify-content-center align-items-center'>
        {documentURL ? (
          <MarkedImage src={documentURL} des={des} marks={marks} />
        ) : (
          <div className='w-100 webcam-no-image rounded'>
            {t('activity-document-photo.no-image')}
          </div>
        )}
      </div>
    </>
  )
}

export default ActivityMarkPhoto
